<template>
  <div class="card shadow-sm border border-light mb-4">
    <div class="p-3 pb-0 card-header">
      <h6 class="mb-2">Aktiv işlər sığorta növləri üzrə</h6>

      <div class="filter-buttons mt-2">
        <button v-for="type in types" :key="type" type="button" class="filter-btn"
          :class="{ active: selectedType === type }" @click="selectedType = type">
          {{ type }}
        </button>
      </div>
    </div>

    <div class="p-3 card-body">
      <div v-if="isLoading" class="text-center p-4">
        <div class="spinner-border text-primary" role="status"></div>
      </div>

      <div v-else-if="hasData" class="row">
        <div class="text-center col-5">
          <doughnut-chart :key="chartKey" :id="'insurance-pie'" :height="'200'" :chart="chartData" />
        </div>

        <div class="col-7">
          <div class="table-responsive">
            <table class="table mb-0 align-items-center">
              <tbody>
                <tr v-for="(item, index) in currentItems" :key="index">
                  <td>
                    <div class="px-2 py-0 d-flex">
                      <span :style="{
                        backgroundColor: item.color,
                        display: 'inline-block',
                        width: '10px',
                        height: '10px',
                        borderRadius: '50%',
                        marginTop: '6px',
                      }" class="me-2"></span>
                      <div class="d-flex flex-column justify-content-center">
                        <h6 class="mb-0 text-sm">{{ item.label }}</h6>
                      </div>
                    </div>
                  </td>
                  <td class="text-sm text-center align-middle">
                    <span class="text-xs font-weight-bold">{{ item.value }}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div v-else class="text-center p-4">
        <p class="text-muted">Məlumat tapılmadı</p>
      </div>
    </div>
  </div>
</template>

<script>
import DoughnutChart from "@/examples/Charts/DoughnutChart.vue";
import { GetInsTypeStats } from "@/project/Source/stats.js";

export default {
  name: "CasesByInsuranceTypePie",
  components: { DoughnutChart },
  data() {
    return {
      selectedType: "NV",
      types: ["NV", "Əmlak", "Digər"],
      rawData: [],
      // фиксируем цвета по типам
      colorMap: {
        1: "#2152ff", // İcbari — синий
        2: "#ff4d4f", // Könüllü — красный
        default: "#3A416F"
      },
      isLoading: true
    };
  },
  computed: {
    currentItems() {
      return this.rawData
        .filter(x => x.category === this.selectedType)
        .map(x => ({
          id: x.insuranceTypeId,
          label: this.getLabelById(x.insuranceTypeId),
          value: x.caseCount,
          color: this.colorMap[x.insuranceTypeId] || this.colorMap.default
        }));
    },
    total() {
      return this.currentItems.reduce((sum, item) => sum + item.value, 0);
    },
    hasData() {
      return !this.isLoading && this.currentItems.length > 0;
    },
    chartKey() {
      return `${this.selectedType}-${this.currentItems.length}-${this.total}`;
    },
    chartData() {
      if (!this.hasData) return null
      return {
        labels: this.currentItems.map(x => x.label),
        datasets: [
          {
            label: "Sığorta növü",
            data: this.currentItems.map(x => x.value),
            backgroundColor: this.currentItems.map(x => x.color),
            borderColor: "#fff",
            borderWidth: 2,
            hoverOffset: 4
          }
        ]
      }
    }

  },
  watch: {
    selectedType() {
      this.$nextTick(() => this.$forceUpdate());
    }
  },
  mounted() {
    this.loadData();
  },
  methods: {
    getLabelById(id) {
      switch (id) {
        case 1:
          return "İcbari";
        case 2:
          return "Könüllü";
        default:
          return "Digər";
      }
    },
    async loadData() {
      try {
        this.isLoading = true;
        const res = await GetInsTypeStats();
        this.rawData = res.data.data || [];

        if (this.rawData.length > 0) {
          const availableTypes = [...new Set(this.rawData.map(x => x.category))];
          if (!availableTypes.includes(this.selectedType) && availableTypes.length > 0) {
            this.selectedType = availableTypes[0];
          }
        }
      } catch (e) {
        console.error("Sığorta növü statistikası yüklənmədi:", e);
      } finally {
        this.isLoading = false;
      }
    }
  }
};
</script>

<style scoped>
.filter-buttons {
  display: flex;
  gap: 8px;
  margin-top: 4px;
  flex-wrap: wrap;
}

.filter-btn {
  border: 1px solid #d0d5dd;
  border-radius: 6px;
  padding: 4px 12px;
  font-size: 12px;
  background-color: #fff;
  color: #344767;
  transition: all 0.15s ease;
  cursor: pointer;
}

.filter-btn:hover {
  background-color: #f4f4f4;
}

.filter-btn.active {
  background-color: #2152ff;
  color: white;
  border-color: #2152ff;
}

.spinner-border {
  width: 3rem;
  height: 3rem;
}
</style>
